"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DueDateDisplay = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _InlineValueDisplay = require("../../utils/components/InlineValueDisplay");
var _dateUtils = require("../../utils/data/dateUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DueDateDisplay = _ref => {
  let {
    dueDate,
    closedBy
  } = _ref;
  if (!dueDate) {
    return /*#__PURE__*/_react.default.createElement("div", null, _InlineValueDisplay.InlineValueDisplay.EMPTY);
  }
  const isIssueClosed = !!closedBy;
  const date = (0, _dateUtils.getDateStringAsDate)(dueDate);
  const dateView = (0, _dateUtils.getDateStringAsDisplayText)(dueDate);
  const color = (0, _dateUtils.isDateOverdue)(date) && !isIssueClosed ? _alloyReactTheme.default.colors.red500 : "inherit";
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color
    }
  }, dateView);
};
exports.DueDateDisplay = DueDateDisplay;
//# sourceMappingURL=DueDateDisplay.js.map